export default function SearchInput({ value, onChange, placeholder = "Search…", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="w-72 rounded-full border border-palette-gray-divider bg-white px-4 py-2 text-sm text-palette-gray-heading shadow-sm focus:border-palette-indigo-label focus:outline-none focus:ring-2 focus:ring-palette-indigo-label/40"
      />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-palette-gray-placeholder">
        🔍
      </span>
    </div>
  );
}
